import axios from 'axios';

export const resolveBaseURL = () => {
  try {
    const { hostname, origin } = window.location;
    if (hostname.includes('localhost')) {
      return 'https://adminrotary.codiatest.com/';
    }
    return origin;
  } catch (e) {
    return 'https://adminrotary.codiatest.com/';
  }
};

/** Toplantı galerisi görsel URL'lerini tam URL'e çevirir. Backend /Meetings/... döner, gerçek adres base + /api/meetings + path. */
export const resolveMeetingAssetUrl = (path) => {
  if (!path || typeof path !== 'string') return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base = resolveBaseURL().replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}/api/meetings${normalizedPath}`;
};

export const httpClientMeetings = axios.create({
  baseURL: resolveBaseURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain',
  },
  withCredentials: true,
});

httpClientMeetings.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth.token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

httpClientMeetings.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401 hatası durumunda token'ı kontrol et
    if (error.response?.status === 401) {
      console.error('401 Unauthorized - Token:', localStorage.getItem('auth.token') ? 'Token var' : 'Token yok');
      console.error('Request URL:', error.config?.url);
      console.error('Request Headers:', error.config?.headers);
    }
    return Promise.reject(error);
  }
);

export default httpClientMeetings;
